// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableContainer,
//   TableHead,
//   Tooltip,
//   Typography,
//   Grid,
// } from "@mui/material";
// import styles from "../../../styles.module.css";
// import {
//   Breadcrumb,
//   CustomePopover,
//   dateConversion,
//   DeleteDialog,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import HeaderSection from "../../reusableComponent/HeaderSection";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import transferToDepotService from "../../../services/transferToDepot.Service";
// import CloseIcon from "@mui/icons-material/Close";
// import CustomPagination from "../../reusableComponent/CustomPagination";

// const ListTransferToDepot = () => {
//   const defaultRowsPerPage = useSelector(
//     (state) => state.inward?.rows_per_page || 15
//   );

//   const [rows, setRows] = useState([]);
//   const [searchKey, setSearchKey] = useState("");
//   const [isDelete, setIsDelete] = useState(false);
//   const [deleteInfo, setDeleteInfo] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
//   const [total_count, setTotalCount] = useState(null);
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   useEffect(() => {
//     if (rows && rows.length > 0) {
//       setTotalCount(rows[0]?.totalCount || rows[0]?.total_count || rows.length);
//     }
//   }, [rows]);

//   useEffect(() => {
//     setController((prev) => ({
//       ...prev,
//       rowsPerPage: defaultRowsPerPage,
//       page: 0,
//     }));
//   }, [defaultRowsPerPage]);

//   const safeParse = (jsonString) => {
//     if (jsonString && typeof jsonString === "string") {
//       try {
//         return JSON.parse(jsonString) || [];
//       } catch (e) {
//         return [];
//       }
//     }
//     return [];
//   };

//   const fetchData = async () => {
//     try {
//       const params = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey,
//       };
//       const response = await transferToDepotService.getTransferToDepotList(params);
//       setRows(Array.isArray(response) ? response : []);
//     } catch (error) {
//       console.error("Error fetching Transfer to Depot data:", error);
//       setSuccessMessage("Error fetching data");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [controller, searchKey]);

//   const handleChangePage = (event, newPage) => {
//     setController((prev) => ({ ...prev, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       ...controller,
//       rowsPerPage: parseInt(event.target.value, 10),
//       page: 0,
//     });
//   };

//   const handleSearch = (e) => {
//     setSearchKey(e.target.value);
//   };

//   const handleDelete = (row) => {
//     setIsDelete(true);
//     setDeleteInfo(row);
//   };

//   const deleteRecord = async (id) => {
//     try {
//       const login_details = sessionStorage.getItem("loginUser");
//       const userD = JSON.parse(login_details);
//       const user_id = userD?.result?.userInfo?.user_id;
//       await transferToDepotService.editDeleteTransferToDepot({
//         entry_id: id,
//         is_deleted: 1,
//         modified_by: user_id,
//       });
//       setIsDelete(false);
//       fetchData();
//       setSuccessMessage("Record deleted successfully");
//     } catch (error) {
//       console.error("Error deleting record:", error);
//       setSuccessMessage("Error deleting record");
//     }
//   };

//   const handleClose = () => {
//     setIsDelete(false);
//     setDeleteInfo(null);
//   };

//   const handleOpenDialog = (row) => {
//     setSelectedRow(row);
//     setSelectedCylinderDetails(safeParse(row.table_details));
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedRow(null);
//     setSelectedCylinderDetails([]);
//   };

//   const getCylinderCount = (tableDetails) => {
//     try {
//       return safeParse(tableDetails).length || 0;
//     } catch {
//       return 0;
//     }
//   };

//   const effectiveTotalCount =
//     total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
//   const startRecord =
//     effectiveTotalCount === 0
//       ? 0
//       : controller.page * controller.rowsPerPage + 1;
//   const endRecord =
//     effectiveTotalCount === 0
//       ? 0
//       : Math.min(
//           (controller.page + 1) * controller.rowsPerPage,
//           effectiveTotalCount
//         );
//   const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

//   return (
//     <Box
//       className={`${styles.cts_page}`}
//       sx={{ padding: "0px !important", margin: "0px !important" }}
//     >
//       <Box className={`${styles.body}`}>
//         <Breadcrumb routeSegments={[{ name: "Transfer to Depot List" }]} />

//         <HeaderSection
//           title="TRANSFER TO DEPOT LIST"
//           addNewPath="/storeEntries/add-transfer-to-depot"
//           searchKey={searchKey}
//           handleSearch={handleSearch}
//           sortedRows={rows}
//           filename="Transfer to Depot List"
//           paginationInfo={paginationInfo}
//           controller={controller}
//           handleChangePage={handleChangePage}
//           handleChangeRowsPerPage={handleChangeRowsPerPage}
//           fields={[
//             "entry_no",
//             "entry_date",
//             "batch_no",
//             "from_location",
//             "to_location",
//             "table_details",
//           ]}
//           labels={[
//             "Entry No",
//             "Entry Date",
//             "Batch No",
//             "From Location",
//             "To Location",
//             "No Of Cylinders",
//           ]}
//         />

//         <Paper sx={{ width: "100%", overflow: "hidden" }}>
//           <TableContainer
//             component={Paper}
//             className={`${styles.list_tbl_container}`}
//             sx={{
//               maxHeight: "calc(100vh - 250px)",
//               overflowY: "auto",
//               overflowX: "auto",
//             }}
//           >
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell align="left" className={styles.table_head}>
//                     Entry No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" className={styles.table_head}>
//                     Entry Date
//                   </StyledTableCell>
//                   <StyledTableCell align="left" className={styles.table_head}>
//                     Batch No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" className={styles.table_head}>
//                     From Plant
//                   </StyledTableCell>
//                   <StyledTableCell align="left" className={styles.table_head}>
//                     To Depot
//                   </StyledTableCell>
//                   <StyledTableCell align="center" className={styles.table_head}>
//                     No of Cylinders
//                   </StyledTableCell>
//                   <StyledTableCell align="center" className={styles.table_head}>
//                     Action
//                   </StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>
//               <TableBody>
//                 {rows.length === 0 ? (
//                   <StyledTableRow>
//                     <StyledTableCell colSpan={7} align="center">
//                       <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>
//                         No records found
//                       </Typography>
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ) : (
//                   rows.map((row, index) => (
//                     <StyledTableRow key={row.entry_id || index}>
//                       <StyledTableCell align="left">
//   <Typography
//     sx={{ fontSize: "12px", cursor: "pointer", color: "#1976d2", fontWeight: 600 }}
//     onClick={() => handleOpenDialog(row)}
//   >
//     {row.entry_no || "-"}
//   </Typography>
// </StyledTableCell>
//                       <StyledTableCell align="left">
//                         {row.entry_date ? dateConversion(row.entry_date) : "-"}
//                       </StyledTableCell>
//                       <StyledTableCell align="left">
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             fontWeight: 500,
                           
//                             fontSize: "12px",
//                           }}
//                         >
//                           {row.batch_no || "-"}
//                         </Typography>
//                       </StyledTableCell>
//                       <StyledTableCell align="left">
//                         {row.from_plant_name || row.from_location || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell align="left">
//                         {row.to_depot_name || row.to_location || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell align="center">
//                         <Button
//                           size="small"
//                           variant="outlined"
//                           sx={{ fontSize: "11px", textTransform: "none" }}
//                           onClick={() => handleOpenDialog(row)}
//                         >
//                           {row.no_cylinder ?? getCylinderCount(row.table_details)} Cyl
//                         </Button>
//                       </StyledTableCell>
//                       <StyledTableCell align="center">
//                         <CustomePopover
//                           onDelete={() => handleDelete(row)}
//                           hideEdit={true}
//                         />
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Paper>

//         <CustomPagination
//           count={effectiveTotalCount}
//           page={controller.page}
//           rowsPerPage={controller.rowsPerPage}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Box>

//       {/* Cylinder Details Dialog */}
//       <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
//         <DialogTitle
//           sx={{
//             background: "#1C3A5E",
//             color: "#fff",
//             fontSize: "14px",
//             fontWeight: 600,
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             py: 1.5,
//           }}
//         >
//           Cylinder Details — {selectedRow?.entry_no} | Batch: {selectedRow?.batch_no}
//           <IconButton onClick={handleCloseDialog} sx={{ color: "#fff" }} size="small">
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0 }}>
//           <TableContainer>
//             <Table size="small">
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell>#</StyledTableCell>
//                   <StyledTableCell>Cylinder No</StyledTableCell>
//                   <StyledTableCell>Bar Code</StyledTableCell>
//                   <StyledTableCell>Product</StyledTableCell>
//                   <StyledTableCell>QC Result</StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>
//               <TableBody>
//                 {selectedCylinderDetails.length === 0 ? (
//                   <StyledTableRow>
//                     <StyledTableCell colSpan={5} align="center">
//                       No cylinder details available
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ) : (
//                   selectedCylinderDetails.map((cyl, idx) => (
//                     <StyledTableRow key={idx}>
//                       <StyledTableCell>{idx + 1}</StyledTableCell>
//                       <StyledTableCell>{cyl.cylinder_no || "-"}</StyledTableCell>
//                       <StyledTableCell>{cyl.bar_code || cyl.barcode || "-"}</StyledTableCell>
//                       <StyledTableCell>
//                         {cyl.prod_code || cyl.prod_description || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell>
//                         <Typography
//                           sx={{
//                             fontSize: "11px",
//                             fontWeight: 600,
//                             color: cyl.quality_result === "Ok" ? "#2e7d32" : "#c62828",
//                           }}
//                         >
//                           {cyl.quality_result || "-"}
//                         </Typography>
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>
//       </Dialog>

//       {/* Delete Confirmation */}
//       {isDelete && (
//         <DeleteDialog
//           open={isDelete}
//           onClose={handleClose}
//           onDelete={() => deleteRecord(deleteInfo?.entry_id)}
//           title="Delete Transfer to Depot"
//           message={`Are you sure you want to delete entry ${deleteInfo?.entry_no}?`}
//         />
//       )}

//       <ReusableSnackbar
//         message={successMessage}
//         onClose={() => setSuccessMessage(null)}
//       />
//     </Box>
//   );
// };

// export default ListTransferToDepot;











import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import styles from "../../../styles.module.css";
import {
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DeleteDialog,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import transferToDepotService from "../../../services/transferToDepot.Service";
import CloseIcon from "@mui/icons-material/Close";
import CustomPagination from "../../reusableComponent/CustomPagination";

const ListTransferToDepot = () => {
  const defaultRowsPerPage = useSelector(
    (state) => state.inward?.rows_per_page || 15
  );

  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [total_count, setTotalCount] = useState(null);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  useEffect(() => {
    if (rows && rows.length > 0) {
      setTotalCount(rows[0]?.totalCount || rows[0]?.total_count || rows.length);
    }
  }, [rows]);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString) || [];
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey,
      };
      const response = await transferToDepotService.getTransferToDepotList(params);
      setRows(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Error fetching Transfer to Depot data:", error);
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const deleteRecord = async (id) => {
    try {
      const login_details = sessionStorage.getItem("loginUser");
      const userD = JSON.parse(login_details);
      const user_id = userD?.result?.userInfo?.user_id;
      await transferToDepotService.editDeleteTransferToDepot({
        entry_id: id,
        is_deleted: 1,
        modified_by: user_id,
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      console.error("Error deleting record:", error);
      setSuccessMessage("Error deleting record");
    }
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.table_details));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const getCylinderCount = (tableDetails) => {
    try {
      return safeParse(tableDetails).length || 0;
    } catch {
      return 0;
    }
  };

  const effectiveTotalCount =
    total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord =
    effectiveTotalCount === 0
      ? 0
      : controller.page * controller.rowsPerPage + 1;
  const endRecord =
    effectiveTotalCount === 0
      ? 0
      : Math.min(
          (controller.page + 1) * controller.rowsPerPage,
          effectiveTotalCount
        );
  const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

  return (
    <Box
      className={`${styles.cts_page}`}
      sx={{ padding: "0px !important", margin: "0px !important" }}
    >
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Transfer to Depot List" }]} />

        <HeaderSection
          title="TRANSFER TO DEPOT LIST"
          addNewPath="/storeEntries/add-transfer-to-depot"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={rows}
          filename="Transfer to Depot List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          fields={["entry_no","entry_date","batch_no","from_location","to_location","table_details"]}
          labels={["Entry No","Entry Date","Batch No","From Location","To Location","No Of Cylinders"]}
        />

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            component={Paper}
            className={`${styles.list_tbl_container}`}
            sx={{ maxHeight: "calc(100vh - 250px)", overflowY: "auto", overflowX: "auto" }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" className={styles.table_head}>Entry No</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Entry Date</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Batch No</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>From Plant</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>To Depot</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>No of Cylinders</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>
                        No records found
                      </Typography>
                    </StyledTableCell>
                  </StyledTableRow>
                ) : (
                  rows.map((row, index) => (
                    <StyledTableRow key={row.entry_id || index}>
                      {/* ✅ Entry No — clickable */}
                      <StyledTableCell align="left">
                        <Typography
                          sx={{ fontSize: "12px", cursor: "pointer", color: "#1976d2", fontWeight: 600 }}
                          onClick={() => handleOpenDialog(row)}
                        >
                          {row.entry_no || "-"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.entry_date ? dateConversion(row.entry_date) : "-"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "12px" }}>
                          {row.batch_no || "-"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.from_plant_name || row.from_location || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.to_depot_name || row.to_location || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Tooltip title="Click to view cylinder details" arrow>
                          <span
                            
                            style={{ cursor: "pointer", fontWeight: 500, fontSize: "12px" }}
                          >
                            {row.no_cylinder ?? getCylinderCount(row.table_details)}
                          </span>
                        </Tooltip>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomePopover
                          onDelete={() => handleDelete(row)}
                          hideEdit={true}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <CustomPagination
          count={effectiveTotalCount}
          page={controller.page}
          rowsPerPage={controller.rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>

      {/* ── TRANSFER TO DEPOT DETAILS DIALOG (same design as Inspection) ── */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            margin: "auto",
            width: "92vw",
            maxHeight: "85vh",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            overflow: "hidden",
            fontFamily: "'Inter', Arial, sans-serif",
          },
        }}
      >
        {/* ── Dialog Header (Navy) ── */}
        <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
            TRANSFER TO DEPOT DETAILS
          </Typography>
          <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

          {/* ── Entry Information Card ── */}
          <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
            {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                🚚 Transfer Information
              </Typography>
            </Box> */}
            <Box>
              <Grid container>
                <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.entry_date)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch No</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2B6CB0", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_no || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>From Plant</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.from_plant_name || selectedRow?.from_location || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>To Depot</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.to_depot_name || selectedRow?.to_location || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={2} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Total Cylinders</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedCylinderDetails.length}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Cylinder Details Table ── */}
          <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
            {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                🛢️ Cylinder Details
              </Typography>
            </Box> */}
            <TableContainer sx={{ maxHeight: "400px" }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <StyledTableRow>
                    {["Sr No", "Cylinder No", "Bar Code",  "QC Result"].map((header) => (
                      <StyledTableCell
                        key={header}
                        align="center"
                        sx={{
                          backgroundColor: "#1C3A5E !important",
                          color: "#fff !important",
                          fontFamily: "'Inter', Arial, sans-serif",
                          fontWeight: 700,
                          fontSize: "11px",
                          padding: "10px 8px",
                          whiteSpace: "nowrap",
                          borderRight: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        {header}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {selectedCylinderDetails.length > 0 ? (
                    selectedCylinderDetails.map((cyl, idx) => (
                      <StyledTableRow
                        key={idx}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#fff" : "#F8FAFC",
                          "&:hover": { backgroundColor: "#EBF4FF" },
                        }}
                      >
                        <StyledTableCell align="center" sx={{ fontSize: "11px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", padding: "8px 6px", borderBottom: "1px solid #EDF2F7" }}>{idx + 1}</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontSize: "11px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", padding: "8px 6px", borderBottom: "1px solid #EDF2F7" }}>{cyl.cylinder_no || "N/A"}</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontSize: "11px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", padding: "8px 6px", borderBottom: "1px solid #EDF2F7" }}>{cyl.bar_code || cyl.barcode || "N/A"}</StyledTableCell>
                        {/* <StyledTableCell align="center" sx={{ fontSize: "11px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", padding: "8px 6px", borderBottom: "1px solid #EDF2F7" }}>{cyl.prod_code || cyl.prod_description || "N/A"}</StyledTableCell> */}
                        <StyledTableCell align="center" sx={{ fontSize: "11px", padding: "8px 6px", borderBottom: "1px solid #EDF2F7" }}>
                          <Typography sx={{ fontSize: "11px", fontWeight: 600, color: cyl.quality_result === "Ok" ? "#2e7d32" : "#c62828" }}>
                            {cyl.quality_result || "N/A"}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={5}
                        align="center"
                        sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                      >
                        No cylinder details available
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </DialogContent>

        {/* ── Dialog Footer ── */}
        <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleCloseDialog}
            sx={{
              background: "#E53E3E",
              color: "#fff",
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "none",
              padding: "7px 20px",
              borderRadius: "8px",
              fontFamily: "'Inter', Arial, sans-serif",
              "&:hover": { background: "#971f16" },
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>

      {/* Delete Confirmation */}
      {isDelete && (
        <DeleteDialog
          open={isDelete}
          onClose={handleClose}
          onDelete={() => deleteRecord(deleteInfo?.entry_id)}
          title="Delete Transfer to Depot"
          message={`Are you sure you want to delete entry ${deleteInfo?.entry_no}?`}
        />
      )}

      <ReusableSnackbar
        message={successMessage}
        onClose={() => setSuccessMessage(null)}
      />
    </Box>
  );
};

export default ListTransferToDepot;

